export default __webpack_public_path__ + "static/media/lydian-light.96e33a3f.svg";